import React, { useEffect, useState } from 'react'

import { Link as RouterLink } from 'react-router-dom'

import useFirebase from 'hooks/firebase'

import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from '@mui/material'

import EditIcon from '@mui/icons-material/Edit'
import NoteAltIcon from '@mui/icons-material/NoteAlt'

const EducationalInformation = (props) => {
  const { student } = props

  const { firestore } = useFirebase()
  const { getSchool, school, updateDocFromCollection } = firestore

  const [open, setOpen] = useState(false)

  const [edit, setEdit] = useState('')

  const [stages, setStages] = useState([])

  const [level, setLevel] = useState(student.level)
  const handleLevelChanged = (event) => {
    setLevel(event.target.value)
  }

  const [grades] = useState(['1°', '2°', '3°', '4°', '5°', '6°'])
  const [grade, setGrade] = useState(student.grade)
  const handleGradeChanged = (event) => {
    setGrade(event.target.value)
  }
  
  const [groups] = useState(['A', 'B', 'C', 'D', 'E', 'F'])
  const [group, setGroup] = useState(student.group)
  const handleGroupChanged = (event) => {
    setGroup(event.target.value)
  }

  const onEdit = async () => {
    setOpen(true)

    if (edit === 'level') {
      await updateDocFromCollection('students', student.id, { 'level': level })
    }

    if (edit === 'grade') {
      await updateDocFromCollection('students', student.id, { 'grade': grade })
    }

    if (edit === 'group') {
      await updateDocFromCollection('students', student.id, { 'group': group })
    }

    setEdit('')
    setOpen(false)
  }

  const onCancel = () => {
    setEdit('')
  }

  useEffect(() => {
    getSchool(student.schoolId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fixedStages = ['Kinder', 'Primaria', 'Secundaria', 'Preparatoria']
  useEffect(() => {
    if (school === undefined) return
    const sortedStages = school.stages !== undefined ? school.stages : []
    sortedStages.sort((a, b) => fixedStages.indexOf(a) - fixedStages.indexOf(b))
    setStages(sortedStages)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [school])

  return (
    <Card sx={{ borderRadius: 2, p: 2 }}>
      { /* <Card sx={{ borderRadius: 2, p: 2 }}>
      <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color='primary' variant='body1'>
              <b style={{ fontWeight: 900 }}>INFORMACIÓN EDUCATIVA</b>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List disablePadding>
              <ListItem 
                secondaryAction={
                  <IconButton edge='end' size='small'>
                    <EditIcon color='lightPurple' fontSize='small' />
                  </IconButton>
                } 
                sx={{ p: 0 }}
              >
                <ListItemText primary={<b>Nivel</b>} secondary={student.level !== undefined ? student.level : 'Sin asignar'} />
              </ListItem>
              <ListItem 
                secondaryAction={
                  <IconButton edge='end' size='small'>
                    <EditIcon color='lightPurple' fontSize='small' />
                  </IconButton>
                } 
                sx={{ p: 0 }}
              >
                <ListItemText primary={<b>Grado</b>} secondary={student.grade !== undefined ? student.grade : 'Sin asignar'} />
              </ListItem>
              <ListItem 
                secondaryAction={
                  <IconButton edge='end' size='small'>
                    <EditIcon color='lightPurple' fontSize='small' />
                  </IconButton>
                } 
                sx={{ p: 0 }}
              >
                <ListItemText primary={<b>Grupo</b>} secondary={student.group !== undefined ? student.group : 'Sin asignar'} />
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  */ }
      <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color='primary' variant='body1'>
              <b style={{ fontWeight: 900 }}>INFORMACIÓN EDUCATIVA</b>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List disablePadding>
              {
                edit === 'level' ? (
                  <ListItem sx={{ p: 0, py: 2 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <FormControl fullWidth variant='outlined'>
                          <InputLabel shrink id='select-outlined-stage'>Nivel</InputLabel>
                          <Select
                            labelId='select-outlined-stage'
                            id='select-outlined-stage'
                            onChange={handleLevelChanged}
                            value={level}
                            label='Nivel'
                            notched
                          >
                            {/* <MenuItem value='Any'>
                              <em></em>
                            </MenuItem> */}
                            { 
                              stages.map((stage, index) =>
                                <MenuItem key={`stage_${index}`} value={stage}>
                                  {stage}
                                </MenuItem>
                              )
                            }
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} align='right'>
                        <Button color='lightPurple' disableElevation variant='contained' onClick={onCancel}>
                          <b>Cancelar</b>
                        </Button>
                        <Button color='lightGreen' disableElevation variant='contained' sx={{ ml: 1 }} onClick={onEdit}>
                          <b>Guardar</b>
                        </Button>
                      </Grid>
                    </Grid>
                  </ListItem>
                ) : (
                  <ListItem 
                    secondaryAction={
                      <IconButton edge='end' size='small' onClick={() => setEdit('level')}>
                        <EditIcon color='lightPurple' fontSize='small' />
                      </IconButton>
                    } 
                    sx={{ p: 0 }}
                  >
                    <ListItemText primary={<b>Nivel</b>} secondary={student.level !== undefined ? student.level : 'Sin asignar'} />
                  </ListItem>
                )
              }
              {
                edit === 'grade' ? (
                  <ListItem sx={{ p: 0, py: 2 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <FormControl fullWidth variant='outlined'>
                          <InputLabel shrink id='select-outlined-grade'>Grado</InputLabel>
                          <Select
                            labelId='select-outlined-grade'
                            id='select-outlined-grade'
                            onChange={handleGradeChanged}
                            value={grade}
                            label='Grado'
                            notched
                          >
                            {/* <MenuItem value='Any'>
                              <em></em>
                            </MenuItem> */}
                            { 
                              grades.map((grade, index) =>
                                <MenuItem key={`grade_${index}`} value={grade}>
                                  {grade}
                                </MenuItem>
                              )
                            }
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} align='right'>
                        <Button color='lightPurple' disableElevation variant='contained' onClick={onCancel}>
                          <b>Cancelar</b>
                        </Button>
                        <Button color='lightGreen' disableElevation variant='contained' sx={{ ml: 1 }} onClick={onEdit}>
                          <b>Guardar</b>
                        </Button>
                      </Grid>
                    </Grid>
                  </ListItem>
                ) : (
                  <ListItem 
                    secondaryAction={
                      <IconButton edge='end' size='small' onClick={() => setEdit('grade')}>
                        <EditIcon color='lightPurple' fontSize='small' />
                      </IconButton>
                    } 
                    sx={{ p: 0 }}
                  >
                    <ListItemText primary={<b>Grado</b>} secondary={student.grade !== undefined ? student.grade : 'Sin asignar'} />
                  </ListItem>
                )
              }
              {
                edit === 'group' ? (
                  <ListItem sx={{ p: 0, py: 2 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <FormControl fullWidth variant='outlined'>
                          <InputLabel shrink id='select-outlined-group'>Grupo</InputLabel>
                          <Select
                            labelId='select-outlined-group'
                            id='select-outlined-group'
                            onChange={handleGroupChanged}
                            value={group}
                            label='Grupo'
                            notched
                          >
                            {/* <MenuItem value='Any'>
                              <em></em>
                            </MenuItem> */}
                            { 
                              groups.map((group, index) =>
                                <MenuItem key={`grade_${index}`} value={group}>
                                  {group}
                                </MenuItem>
                              )
                            }
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} align='right'>
                        <Button color='lightPurple' disableElevation variant='contained' onClick={onCancel}>
                          <b>Cancelar</b>
                        </Button>
                        <Button color='lightGreen' disableElevation variant='contained' sx={{ ml: 1 }} onClick={onEdit}>
                          <b>Guardar</b>
                        </Button>
                      </Grid>
                    </Grid>
                  </ListItem>
                ) : (
                  <ListItem 
                    secondaryAction={
                      <IconButton edge='end' size='small' onClick={() => setEdit('group')}>
                        <EditIcon color='lightPurple' fontSize='small' />
                      </IconButton>
                    } 
                    sx={{ p: 0 }}
                  >
                    <ListItemText primary={<b>Grupo</b>} secondary={student.group !== undefined ? student.group : 'Sin asignar'} />
                  </ListItem>
                )
              }
            </List>
          </Grid>
          <Grid item xs={12}>
            <Button color='secondary' component={RouterLink} disableElevation fullWidth startIcon={<NoteAltIcon />} to='record' variant='contained'>
              <b style={{ fontWeight: 900 }}>VER EXPEDIENTE</b>
            </Button>
          </Grid>
        </Grid>
      </CardContent>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
    </Card>
  )
}

export default EducationalInformation